import scrollDelay from './src/gatsby/browser/shouldUpdateScroll'
import CustomLayout from './src/gatsby/browser/wrapPageElement'
import '@fontsource-variable/inter'
import '@fontsource-variable/eb-garamond'
export const wrapPageElement = CustomLayout
export const shouldUpdateScroll = scrollDelay
